import { capitalize } from 'lodash';

/**
 * Joins an array of items with a comma and an 'and' before the last item.
 */
export const joinWithCommas = (items: string[]): string => {
  if (items.length === 1) {
    return items[0];
  }

  const allItemsButLast = items.slice(0, -1);
  const lastItem = items.slice(-1);

  return `${allItemsButLast.join(', ')} and ${lastItem}`;
};

export const highLowText = (props: {
  isAttrition: boolean;
  difference: 'same' | 'better' | 'worse';
}) => {
  const { isAttrition, difference } = props;

  if (difference === 'same') {
    return '';
  }

  if (difference === 'better') {
    return isAttrition ? 'lower' : 'higher';
  }

  return isAttrition ? 'higher' : 'lower';
};

export const capitalizeFirstLetterInEachSentence = (text: string): string => {
  return text
    .split('. ')
    .map((sentence) => {
      return capitalize(sentence);
    })
    .join('. ');
};

/**
 * Return same string with first letter of each word in uppercase
 */
export const toTitleCase = (str: string) =>
  str.toLowerCase().replace(/(?<!')\b\w/g, (char) => char.toUpperCase());
